import firebase from "gatsby-plugin-firebase"
import "firebase/firestore"
import "firebase/storage"

export const getFirebase = () => {
  if(firebase) {
    return firebase.firestore();
  }
}
export const getFirebaseStorage = () => {
  if(firebase) {
    return firebase.storage();
  }
}